import React from 'react';
import './TabBlock.css';
import ESGSection, { type ESGSlide } from './ESGSection/ESGSection';

export type TabItem = {
  id: string;
  title: string;
  description: string;
};

type Props = {
  tabs?: TabItem[];
  slides?: ESGSlide[];
  sectionTitle?: string;
  sectionDescription?: string;
};
const TabBlock: React.FC<Props> = ({ tabs = [], slides, sectionTitle, sectionDescription }) => {
  return (
    <section id="why" className="tabblock">  
      <h2 className="tabblock-title">{sectionTitle}</h2>
      <p className="tabblock-description">{sectionDescription}</p>    
      <ESGSection slides={slides} />
    </section>
  );
};

export default TabBlock;
